import actions from './actions'
import mutations from './mutations'
import { createResource } from '../../../utils/resource'
import {createPagination, types} from "../../pagination/pagination";
import axios from "axios";

const state = {
  statusItem: void 0,
  item: {},
  userStatus: void 0,
  users: {},
  teamStatus: void 0,
  teams: {}
}

const tasks = createResource('task', {})

const pagination = createPagination({ perPage: 10 })

pagination.actions.getTasks = async ({ commit, dispatch }, { perPage, page, sf, so, completed }) => {
  commit(types.GET_LIST.REQUEST, { page })
  try {
    const result = await axios.get('/api/task', { params: { l: perPage, lo: (page - 1), sf, so, completed } })
    commit(types.GET_LIST.SUCCESS, result)
  } catch (err) {
    commit(types.GET_LIST.FAILURE)
  } finally {
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  modules: {
    pagination
  }
}